'use client'
import { useTranslations, useLocale } from 'next-intl'
import HomeSearchParametersComponent from './components/HomeSearchParametersComponent'
import { useRouter } from 'next/navigation'
import React, { useRef, useState } from 'react'
import AvgComponent from './components/AvgComponent'
import BestOffersComponent from './components/BestOffers'
import InfoList from './components/InfoList/InfoList'
import HomePageOffersComponent from './components/HomePageOffers'

export default function DashboardPage() {
  const t = useTranslations('')

  const [selectedCategory, setSelectedCategory] = useState(7);
  const [selectedType, setSelectedType] = useState(1);

  const currentLanguage: string = useLocale();
  const favoriteIconRef = useRef(null);

  return (
    <main>
      <HomeSearchParametersComponent
        selectedCategory={selectedCategory}
        setSelectedCategory={setSelectedCategory}
        selectedType={selectedType}
        setSelectedType={setSelectedType}
      />

      <AvgComponent/>

      <InfoList />

      <div className="gray-background best-offers container-for-best-offers">
        <section className="container-main">
          <div className="section-title-container">
            <i className="icon-apartment"></i>
            <h1 className="best-offers-section-title">{t('Best Offers')}</h1>
            <p className="best-offers-section-sub-title mb-4">{t('You can find best offers from this list')}</p>
          </div>

          <BestOffersComponent
            category={selectedCategory}
            type={selectedType}
            selectedLang={currentLanguage}
            favoriteIconRef={favoriteIconRef}
          />
        </section>
      </div>

      <HomePageOffersComponent
        selectedType={selectedType}
        selectedLang={currentLanguage}
        favoriteIconRef={favoriteIconRef}
      />
    </main>
  )
}
